import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { BUSINESS } from "@/constants/business";

export default function Testimonials() {
    return (
        <section id="reviews" data-testid="reviews-section" className="py-24 sm:py-32">
            <div className="max-w-7xl mx-auto px-6">
                <motion.div
                    initial={{ opacity: 0, y: 32 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                    className="mb-16 max-w-2xl"
                >
                    <div className="text-xs font-mono uppercase tracking-[0.25em] text-amber-400 font-semibold mb-4">
                        05 / Reviews
                    </div>
                    <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold uppercase tracking-tight text-white leading-tight">
                        Word of mouth, Gympie style
                    </h2>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
                    className="flex flex-wrap items-center justify-between gap-6 rounded-2xl border border-amber-500/30 bg-amber-500/5 px-8 py-7"
                    data-testid="review-cta-banner"
                >
                    <div>
                        <div className="font-display text-2xl font-bold uppercase text-white">
                            Had us out to your place?
                        </div>
                        <div className="text-sm text-zinc-400 mt-1">
                            Your review keeps a local Gympie business on the road — it takes 60 seconds.
                        </div>
                    </div>
                    <motion.a
                        href={BUSINESS.googleReviewUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="google-review-button"
                        whileHover={{ scale: 1.03 }}
                        whileTap={{ scale: 0.97 }}
                        className="inline-flex items-center gap-2 bg-amber-500 text-[#0B0C0E] font-bold uppercase tracking-widest text-xs rounded-full px-6 py-3.5 hover:bg-amber-400 transition-colors duration-200"
                    >
                        <Star className="w-4 h-4 fill-[#0B0C0E]" /> Leave a Google Review
                    </motion.a>
                </motion.div>
            </div>
        </section>
    );
}
